import React from "react"
import { NavHashLink as Link } from 'react-router-hash-link';
import { FaFacebookF, FaTwitter, FaGithub, FaInstagram, FaWhatsapp, FaLinkedinIn} from 'react-icons/all'

const Header = () => {
    
    window.onload = function () {
        const burger = document.querySelector('.burger');
        const hamburger = document.querySelector('.hamburger');
        const nav = document.querySelector('nav');
        const liClick = document.querySelectorAll(".li-click");
        burger.addEventListener('click', ()=> {
            nav.style.maxWidth = '100%';
            nav.style.padding = "20px";
            burger.style.display = "none";
            hamburger.style.display = "flex";
        });
        hamburger.addEventListener('click', ()=> {
            nav.style.maxWidth = '0';
            nav.style.padding = "0";
            burger.style.display = "flex";
            hamburger.style.display = "none";
        });
        for (const link of liClick) {
            link.addEventListener("click", ()=> {
                nav.style.maxWidth = '0';
                nav.style.padding = "0";
                burger.style.display = "flex";
                hamburger.style.display = "none";
        });
        }
    }
    return (
        <header id="home">
            <div className="container">
                <div className="header">
                    <nav>
                        <ul>
                        <li className="li-click"><Link
                                to="/path#home"
                                scroll={el => el.scrollIntoView({ behavior: 'smooth', block: 'start' })}>
                                    Home
                                </Link>
                            </li>
                            <li className="li-click"><Link
                                to="/path#about"
                                scroll={el => el.scrollIntoView({ behavior: 'smooth', block: 'start' })}>
                                    About
                                </Link>
                            </li>
                            <li className="li-click"><Link
                                to="/path#skills"
                                scroll={el => el.scrollIntoView({ behavior: 'smooth', block: 'start' })}>
                                    Skills
                                </Link>
                            </li>
                            <li className="li-click"><Link
                                to="/path#projects"
                                scroll={el => el.scrollIntoView({ behavior: 'smooth', block: 'start' })}>
                                    Projects
                                </Link>
                            </li>
                            <li className="li-click"><Link
                                to="/path#contact"
                                scroll={el => el.scrollIntoView({ behavior: 'smooth', block: 'start' })}>
                                    Contact
                                </Link>
                            </li>
                        </ul>
                    </nav>
                    <div className="burger">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div className="hamburger">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <div className="page-header">
                    <h1>Hello, I'm <br/><span>Benedict Steven</span><br/>Front-end Web developer from Tanzania</h1>
                    <Link className="primary-btn"
                            to="/path#contact"
                            scroll={el => el.scrollIntoView({ behavior: 'smooth', block: 'start' })}>
                                work with me
                            </Link>
                    <div className="social-icons">
                            <a href="https://web.facebook.com/profile.php?id=100006234616525" rel="noopener noreferrer" target="_blank"><FaFacebookF /></a>
                            <a href="https://www.twitter.com/bmsteve96" rel="noopener noreferrer" target="_blank"><FaTwitter /></a>
                            <a href="https://www.github.com/bmsteven" rel="noopener noreferrer" target="_blank"><FaGithub /></a>
                            <a href="https://www.linkedin.com/in/benedict-steven-646724122/" rel="noopener noreferrer" target="_blank"><FaLinkedinIn /></a>
                            <a href="https://www.instagram.com/bensteve_" rel="noopener noreferrer" target="_blank"><FaInstagram /></a>
                            <a href="http://wa.me/255655392445"><FaWhatsapp /></a>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;